import { GiftItem } from "../../types";

export const getMedianPrice = (items: GiftItem[]): number => {
  if (items.length === 0) return 0;

  const prices = items
    .filter((i) => i.id && i.id !== "")
    .map((i) => (typeof i.price === "number" ? i.price : Number(i.price)))
    .filter((price) => !isNaN(price))
    .sort((a, b) => a - b);

  if (prices.length === 0) return 0;

  const mid = Math.floor(prices.length / 2);

  const median =
    prices.length % 2 === 0 ? (prices[mid - 1] + prices[mid]) / 2 : prices[mid];

  return Math.round(median);
};
